import { closeNotification } from '../../components/common/Notification/openNotification.js';
import NestingController from '../core/controllers/nesting/NestingController.js';
import PositionController from '../core/controllers/positioning/PositionController.js';
import PositionControllerCopy from '../core/controllers/positioning/PositionControllerCopy.js';
import { CabinetManager } from '../core/managers/CabinetManager.js';
import SceneManager from './SceneManager.js';
import { roundTo } from '../../utils/geometry/epsilon.js';
import { parseJson } from '../../utils/string/parseJson.js';
import { convertForeignCurrency } from '../../utils/currency/currency.utils.js';

export default class ExtendedSceneManager extends SceneManager {
  constructor(canvasId, onSelectMesh, setNeedUpdatePrice) {
    super(canvasId, onSelectMesh);
    this.cabinetManager = new CabinetManager(this);

    // this.positionController = new PositionController(this, this.labelRenderer);
    this.positionController = new PositionControllerCopy(
      this,
      this.labelRenderer
    );

    this.positionController.setOnDistanceChanged(data => {
      // data contains:
      // - moduleId: ID của module
      // - direction: Hướng (x1, x2, z1, z2)
      // - oldDistance: Khoảng cách cũ
      // - newDistance: Khoảng cách mới
      // - newPosition: Vị trí mới {x, z}
    });
    this.nestingController = new NestingController({
      cabinetManager: this.cabinetManager,
    });
    this.resultEstimatePrice = {};
    this.summaryResutlEstimatePrice = {};
    this.setNeedUpdatePrice = setNeedUpdatePrice;
  }

  updateDefaultViPriceConfig({ priceConfig, profitConfig, ruleConfig }) {
    this.nestingController.updateDefaultViPriceConfig({
      priceConfig,
      profitConfig,
      ruleConfig,
    });
  }

  updateDefaultUsPriceConfig({ priceConfig, profitConfig, ruleConfig }) {
    this.nestingController.updateDefaultUsPriceConfig({
      priceConfig,
      profitConfig,
      ruleConfig,
    });
  }

  importPersistableData(costPersistable, salePersistable) {
    const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
    this.nestingController.pricingAdapterVN.importFromPersistable(
      costPersistable?.[country_code] ?? costPersistable,
      salePersistable?.[country_code] ?? salePersistable
    );
  }

  async calculateTotalCost({
    containerId = 'estimated-cost',
    isFinal = false,
  }) {
    const est = this.nestingController.estimateBoardsNeeded({
      modules: this.cabinetManager.currentCabinet?.modules,
      id: containerId,
      isFinal,
    });
    this.resultEstimatePrice = { ...est };
    if (this.setNeedUpdatePrice) this.setNeedUpdatePrice();

    const spanEstimatedCost = document.getElementById(containerId);

    if (spanEstimatedCost) {
      const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
      spanEstimatedCost.innerHTML = convertForeignCurrency(
        roundTo(est?.grand?.[country_code] ?? 0, 2)
      );
    }

    return this.resultEstimatePrice;
  }

  getResultEstimatePrice() {
    return this.resultEstimatePrice;
  }

  // getEstimateExcelData() {
  //   return this.nestingController.convertToDataExcel();
  // }

  // updatePrice(data) {
  //   this.nestingController.updatePriceConfig(data);
  // }

  // Cabinet design methods
  startCabinetDesign(cabinetType) {
    return this.cabinetManager.startDesign(cabinetType);
  }

  async loadCabinetModule(moduleData, moduleType, yPosition) {
    if (!this.cabinetManager.getCurrentCabinet()) {
      throw new Error(
        'No cabinet design in progress. Please start a cabinet design first.'
      );
    }

    return await this.cabinetManager.addModule(
      moduleData,
      moduleType,
      yPosition
    );
  }

  finishCabinetDesign() {
    return this.cabinetManager.finishDesign();
  }

  getCurrentCabinet() {
    return this.cabinetManager.getCurrentCabinet();
  }

  getCabinetConstraints(cabinetType) {
    return this.cabinetManager.getCabinetConstraints(cabinetType);
  }

  removeCabinetModule(module) {
    this.cabinetManager.removeModule(module);
    closeNotification('over-size-board');
    this.removeBorderErrorMesh();
  }

  clearAllCabinets() {
    this.cabinetManager.clearAll();
  }

  exportCabinetDesigns() {
    return {
      currentDesign: this.cabinetManager.exportCurrentDesign(),
      history: this.cabinetManager.cabinetHistory,
    };
  }

  dispose() {
    // Dọn dẹp các controller của ExtendedSceneManager
    this.positionController?.dispose?.();
    this.nestingController?.dispose?.();
    this.cabinetManager?.dispose?.();

    this.resultEstimatePrice = {};
    this.summaryResutlEstimatePrice = {};
    this.setNeedUpdatePrice = null;

    // Gọi dispose của SceneManager cha
    super.dispose();
  }
}
